// extracted by mini-css-extract-plugin
module.exports = {"heartButton":"FavouriteButton_heartButton__3Sjdm"};